import _ from "lodash";
import { baseActionEpic, defaultCheckError, IRequestAction, IRequestDataAction, progressEpic } from "epics/base-epic";
import { COLOR_SWATCHES } from "constants/action-types";
import siteConfig from "site-config";
import { ISwatch, SwatchType } from "constants/color-swatches";
import { IDownloadState, IUploadState } from "reducers/color-swatches";
import { add as snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";

export const fetchColorSwatches = progressEpic<IRequestAction, ISwatch[]>(
    COLOR_SWATCHES.LIST.FETCH,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url }),
    {
        dataCustomizer: (response, action, store) =>
            action.payload.next ? store.colorSwatches.list.payload.concat(response) : response,
    }
);

interface ISetAction extends IRequestDataAction {
    type?: SwatchType;
}

export const setColorSwatch = progressEpic<ISetAction, ISwatch[]>(
    COLOR_SWATCHES.LIST.SET,
    ({ payload }) => ({
        method: "PUT",
        url: siteConfig.api + payload.url,
        body: payload.body,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            module: "default",
        },
    }),
    {
        dataCustomizer: (response, action, store) =>
            action.payload.type === SwatchType.FILE
                ? _.uniqBy([...response, ...store.colorSwatches.list.payload], "color")
                : store.colorSwatches.list.payload,
        finishActions: (response, action) =>
            action.payload.type === SwatchType.FILE
                ? [snackbarAdd({ message: format("Color Swatch(es) updated successfully") })]
                : [],
    }
);

export const deleteColorSwatch = baseActionEpic<IRequestDataAction>(
    COLOR_SWATCHES.LIST.DELETE,
    ({ payload }) => ({ method: "DELETE", url: siteConfig.api + payload.url, body: payload.body }),
    () => []
);

export const uploadColorSwatches = progressEpic<IRequestDataAction, IUploadState>(
    COLOR_SWATCHES.IMPORT.UPLOAD,
    ({ payload }) => ({
        method: "PUT",
        url: siteConfig.api + payload.url,
        body: payload.body,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            module: "default",
        },
    }),
    {
        finishActions: (response, action, store) =>
            _.compact([
                {
                    type: COLOR_SWATCHES.LIST.UPDATE,
                    payload: _.uniqBy([...response.swatches, ...store.colorSwatches.list.payload], "color"),
                },
                _.isEmpty(response.errorList) &&
                    snackbarAdd({ message: format("Color Swatch(es) updated successfully") }),
            ]),
        checkErrorStatus: defaultCheckError,
    }
);

// prettier-ignore
export const exportColorSwatches = progressEpic<IRequestDataAction, IDownloadState>(
    COLOR_SWATCHES.EXPORT.DOWNLOAD,
    ({ payload }) => ({ method: "POST", url: siteConfig.api + payload.url, body: payload.body })
);
